__turbopack_context__.v({
  "checkBox": "MobileLanguageFilter-module-scss-module__HSpKSG__checkBox",
});
